diy.angular.registerDirective('diyfmmenu', ['$timeout', 'diyfmsectionsdata', '$parse', 
function($timeout, diyfmsectionsdata, $parse) {

    var tpl = '\
        <div class="fm-menu-button" ng-click="closeMenu();">\
            <span class="ui-icon ui-icon-menu-active"></span>\
        </div>\
        <div class="fm-menu-actions-wrap">\
            <ul>\
                <li ng-click="menuAction(_action)" \
                    ng-repeat="_action in actions"\
                    ng-init="buttonConfig = {icons: {primary: \'ui-icon-\' + _action.icon}, label: _action.title}"\
                    >\
                    <button \
                        diybutton="buttonConfig" \
                        class="ui-button-borderless"\
                            ></button>\
                </li>\
            </ul>\
        </div>';

    return {
        template: tpl,
        scope: {
            menuConfig: '=ngModel'
        },
        link: function(scope, elem, attr) {
            var config,
                $elem = jQuery(elem),
                $menuTargetEl, // comes from the config object, just a shortcut to it
                eventNamespace = 'fmmenu' + Math.round(Math.random() * Math.pow(10, 6));

            /* whenever the actions functions changes, update the actions */
            scope.$watchCollection(function() {
                if (!config || !config.getActions) {
                    return undefined;
                }
                // only return actions that have valid action handlers
                // this is done so we can dynamically determine which actions we should display or not
                return config.getActions().filter(function(action) {
                    return 'function' === typeof config[action.name];
z                });
            }, function(newValue, oldValue) {
                scope.actions = newValue;
            });

            var positionedParent, parents = $elem.parents();

            for(var i = 0; i < parents.length; i++) {
                if(jQuery(parents[i]).css('position') !== 'static') {
                    positionedParent = jQuery(parents[i]);
                    break;
                }
            };

            /* forward the actions */
            scope.menuAction = function(_action) {
                if (config[_action.name]) {
                    config[_action.name]($menuTargetEl);
                }
                scope.closeMenu();
            };

            /**
             * open the menu
             * @param ev the event
             * @param targetScope a link to the scope it was opened from, so we can call methods from there
             */
            scope.$watch('menuConfig',  function(newConfig, oldConfig) {

                if (newConfig !== oldConfig) {

                    config = newConfig;

                    /* get the target scope and the target element */
                    $menuTargetEl = config.menuTargetEl;

                    if (!newConfig) {
                        scope.closeMenu();
                        return;
                    }

                    var
                       targetOffs = $menuTargetEl.offset(),
                       positionedParentOffs = positionedParent.offset()
                    ;

                    /* position menu */
                    $elem.css({
                        top: targetOffs.top - positionedParentOffs.top,
                        left: targetOffs.left - positionedParentOffs.left
                    });

                    /* on menu open, register handlers to close it when
                    clicks on the body are received */
                    jQuery('body').bind('mousedown.' + eventNamespace + ' touchstart.' + eventNamespace, function(ev) {
                        if (!jQuery.contains(elem[0], ev.target)) {
                            scope.$apply(function(scope) {
                                scope.closeMenu();
                            });
                        }
                    });
                    $menuTargetEl.parents().bind('scroll.' + eventNamespace, function(ev) {
                        scope.$apply(function(scope) {
                            scope.closeMenu();
                        });
                    });

                    $elem.show();
                }
            });

            /**
             * close the menu
             */
            scope.closeMenu = function() {
                $elem.hide();
                $menuTargetEl.parents().unbind('.' + eventNamespace);
                if (typeof scope.menuConfig.menuClose === 'function') {
                    scope.menuConfig.menuClose();
                }
            };
        }
    };
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmmenu.js
 ** module id = 974
 ** module chunks = 0
 **/